export default __webpack_public_path__ + "static/media/ILUSTRACIONES_11.bab06fc1.png";